import styled from 'styled-components';
import Icon from '@ant-design/icons';

export const ResizableContainer = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 65px);
  min-height: 400px;
`;

export const StyledLeftPanel = styled.div<{ $isDragging: boolean }>`
  overflow: auto;
  height: 100%;
  flex: 0 0 auto;
  transition: ${({ $isDragging }) => ($isDragging ? 'initial' : 'width 0.3s')};
`;

export const StyledRightPanel = styled.div`
  flex: 1 1 auto;
  overflow: auto;
  height: 100%;
`;

export const DragBar = styled.div`
  width: 5px;
  cursor: col-resize;
  background-color: #e9edf0;
  z-index: 100;
  height: 100%;
  position: relative;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
`;

export const DragIcon = styled(Icon)`
  cursor: col-resize;
  position: absolute;
  top: 50%;
  left: -6px;
  transform: translate(-50%, -50%);
  user-select: none;

  &:hover {
    background-color: #e9edf0;
    padding: 2px 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
`;

export const CollapseIcon = styled(Icon)`
  cursor: pointer;
  position: absolute;
  user-select: none;

  width: 28px;
  height: 28px;
  display: block;
  padding: 6px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  top: 18px;
  left: -30px;
  &:hover {
    background: #e9edf0;
  }
  transition: color ease-in 0.3s;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  cursor: col-resize;
  z-index: 9999;
`;

export const LeftOverlay = styled.div`
  position: absolute;
  top: 65px;
  width: 30px;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #ffffff;
  cursor: pointer;
`;
